export const MaterialName = "VMKBBW_065";
export const CarriageDesign = "VWAUBW_065";
export const SizeCode = "VBGR_065";
export const LocatingFace = "VANS_065";
export const StandardKits = "VSKITS_065";
export const Coating = "VBSCH_065";
export const Preload = "VVSP_065";
export const Accuracy = "VGEN_065";
export const GreasingPerGreaseGroup = "VBGG_065";
export const GreasingLType = "VBLT_065";
export const SMDS = "VSMDS_065";
export const CoverStrip = "VADK_065";

export const KitsLeft = "VKLIBW_065";
export const KitsCenter = "VKMI_065";
export const KitsRight = "VKREBW_065";

export const LubricationConnectorOrientation = "VSZBW_065"; // Included, installed...
export const LubricationConnectorPosition = "VSARBW_065"; // Top middle bottom
export const LubricationConnector = "VSA_065";
export const LubricationConnectorAlignment = "VSW_065";
